import Immutable, { Record } from 'immutable';

const AbilityDescriptionRecord = Record({
  abilityId: undefined,
  note: undefined,
});

class AbilityDescription extends AbilityDescriptionRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'abilityId':
      return [key, `${val}`];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

AbilityDescription.create = (data) =>
  new AbilityDescription(data).mapEntries(reviver);

export default AbilityDescription;



// WEBPACK FOOTER //
// ./data/ProgressTests/Skills/SubSkills/AbilityDescriptions/model.js